"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _getSources = _interopRequireDefault(require("../../../actions/source/getSources"));
var _actionUtils = require("../../../utils/actionUtils");
var _StudioLogger = require("@studio/logger/StudioLogger");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var LOG = new _StudioLogger.StudioLogger('sourcesAuditLogger');
function sourceToggled(_ref, _ref2) {
  var dispatch = _ref.dispatch,
    getState = _ref.getState;
  var notifyingDirector = _ref2.notifyingDirector,
    source = _ref2.source;
  if (!(0, _actionUtils.isSameAttendee)(notifyingDirector, getState())) {
    LOG.info('Source Toggle Event Received', {
      notifyingDirector: notifyingDirector,
      source: source
    });
    dispatch((0, _getSources["default"])());
  }
}
var _default = exports["default"] = sourceToggled;